import errorNotification from "./error-notification";

export default errorNotification;